export default __webpack_public_path__ + "static/11.11-41d53d0ee84fab5e721eb89c7da61f30.png";